import React, { Component } from 'react';
import { View, Animated, Text, Platform, Dimensions } from 'react-native'

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import {
  forEach as _forEach,
  isFunction as _isFunction,
  filter as _filter,
  unionBy as _unionBy,
  differenceBy as _differenceBy,
} from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './DashboardDiscover.styles';

class DashboardDiscover extends Component {
  constructor(props) {
    super(props);
    this.scrollY = new Animated.Value(0);
    this._onScroll = Animated.event([{ nativeEvent: { contentOffset: { y: this.scrollY } } }], {
      listener: this.onScroll,
      useNativeDriver: true,
    });
    this.viewabilityConfigCallbackPairs = [
      {
        viewabilityConfig: {
          minimumViewTime: 500,
          itemVisiblePercentThreshold: 15,
        },
        onViewableItemsChanged: this.handleItemsInViewPort,
      },
    ];

    this.currentDisplayedItems = null;
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.isCurrentScreen !== this.props.isCurrentScreen && this.props.isCurrentScreen) ||
      (this.props.isCurrentScreen && !this.props.isBackground)
    ) {
      this.handleScreenIsFocused();
    } else if (
      (prevProps.isCurrentScreen !== this.props.isCurrentScreen && !this.props.isCurrentScreen) ||
      (this.props.isCurrentScreen && this.props.isBackground)
    ) {
      this.handleScreenLostFocus();
    }
  }
  onScroll = evt => {
    this.props.cardsRefs.forEach(item => {
      if (item && _isFunction(item.onScroll)) {
        item.onScroll(this.scrollY);
      }
    });
  };
  handleScreenLostFocus = payload => {
    _forEach(this.currentDisplayedItems, value => {
      if (
        this.props.cardsRefs[value.index] &&
        _isFunction(this.props.cardsRefs[value.index].dispose)
      ) {
        this.props.cardsRefs[value.index].dispose();
      }
    });
  };

  handleScreenIsFocused = payload => {
    _forEach(this.currentDisplayedItems, value => {
      if (
        this.props.cardsRefs[value.index] &&
        _isFunction(this.props.cardsRefs[value.index].init)
      ) {
        this.props.cardsRefs[value.index].init();
      }
    });
  };

  handleItemsInViewPort = ({ changed }) => {
    const newVisibleItems = _filter(changed, value => value.isViewable);
    const newNonVisibleItems = _filter(changed, value => !value.isViewable);

    this.handleNonVisibleItems(newNonVisibleItems);
    this.handleVisibleItems(newVisibleItems);
  };

  handleVisibleItems = visibleItems => {
    this.currentDisplayedItems = _unionBy(this.currentDisplayedItems, visibleItems, 'key');

    // Loop through the items that became visible.
    // (whether or not the item is visible depends on the viewabilityConfig supplied)
    // check if the item that became viewable has a reference and it has an init function defined in it,
    // if so invoke that function.
    _forEach(visibleItems, value => {
      if (
        this.props.cardsRefs[value.index] &&
        _isFunction(this.props.cardsRefs[value.index].init)
      ) {
        this.props.cardsRefs[value.index].init();
      }
    });
  };

  handleNonVisibleItems = nonVisibleItems => {
    this.currentDisplayedItems = _differenceBy(this.currentDisplayedItems, nonVisibleItems, 'key');

    // Loop through the items that became nonvisible.
    // (whether or not the item is not visible depends on the viewabilityConfig supplied)
    // check if the item that became unviewable has a reference and it has a dispose function defined in it,
    // if so invoke that function.
    _forEach(nonVisibleItems, value => {
      if (
        this.props.cardsRefs[value.index] &&
        _isFunction(this.props.cardsRefs[value.index].dispose)
      ) {
        this.props.cardsRefs[value.index].dispose();
      }
    });
  };

  render() {
    const { title, theme, headerTitleStyle } = this.props;

    const DashboardDiscoverCloned = React.cloneElement(this.props.dashboardDiscover, {
      viewabilityConfigCallbackPairs: this.viewabilityConfigCallbackPairs,
      onScroll: this._onScroll,
    });

    return (
      <View
        onLayout={() => {
          // for some reason measureInWindow callbacks with undefined values in android
          // so to make it work as expected..onLayout needs to be called
          // https://github.com/facebook/react-native/issues/3282
          // measureInWindow gets called by setDiscoverRef .. check withDiscoverSnap.js
        }}
        ref={this.props.setDiscoverRef}
        // style={styles.wrapperContainer}
        testID={FrameworkTestKeys.DBdiscoverView}
      >
        {Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : <VFText
          testKey={FrameworkTestKeys.DBdiscoverTitle}
          i18nKey={title}
          style={[styles.headerTitle(theme), headerTitleStyle, { backgroundColor: theme.colors.backgroundColor }]}
        />}
        <View style={styles.wrapper(theme)} testID={FrameworkTestKeys.DBdiscoverViewWrapper}>
          {DashboardDiscoverCloned}
        </View>
      </View>
    );
  }
}

DashboardDiscover.defaultProps = {
  theme: LightThemeColors,
};

DashboardDiscover.propTypes = {
  setDiscoverRef: PropTypes.func,
  dashboardDiscover: PropTypes.element,
  cardsRefs: PropTypes.array,
  isBackground: PropTypes.bool,
  isCurrentScreen: PropTypes.bool,
  items: PropTypes.array,
  title: PropTypes.string.isRequired,
  discoveryItems: PropTypes.array.isRequired,
  isTransitioning: PropTypes.bool,
  index: PropTypes.number,
  routes: PropTypes.array,
  isModalVisible: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  headerTitleStyle: TextPropTypes.style,
};

export default withTheme(DashboardDiscover);
